<template>
  <div class="container">
    <div class="siteMapTitle">网站地图
    </div>
    <div :class="index===0? '':'borderTop'"
         v-for="(menu,index) in content"
         :key="index">
      <div class='menuTitle'>
        <a :href="menu.link">{{menu.title}}</a>
      </div>
      <div class="menuOneContainer">
        <div class="menuOne"
             v-for="(menuOne,index) in menu.children"
             :key="'menuOne_'+index">
          <div class='menuOneTitle'>
            <a :href="menuOne.link">{{menuOne.title}}</a>
          </div>
          <div v-if="menuOne.children">
            <div class="menuTwo"
                 v-for="(menuTwo,index) in menuOne.children"
                 :key="'menuTwo_'+index">
              <a :href="menuTwo.link">{{menuTwo.title}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SiteMap from '../json/siteMap_contents.json'
export default {
  name: 'SiteMap',
  components: {},

  data () {
    return {
      content: ''
    }
  },
  watch: {

  },
  methods: {
  },

  mounted () {
    this.content = SiteMap
    console.log(this.content)
  }
}
</script>

<style scoped >
a {
  text-decoration: none;
  color: inherit;
}
.container {
  display: flex;
  flex-direction: column;
  width: 80%;
  max-width: 1140px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.siteMapTitle {
  font-size: 30px;
  border-bottom: 2px solid #ccc;
  padding: 0 0 10px;
}
.menuTitle {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 0;
}
.borderTop {
  border-top: 2px solid #ccc;
}

.menuOneContainer {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}
@media (max-width: 1200px) {
  .menuOneContainer {
    flex-direction: column;
  }
}

.menuOne {
  width: 33.3333%;
  box-sizing: border-box;
  padding: 0 20px;
}

@media (max-width: 1200px) {
  .menuOne {
    width: 100%;
  }
}

.menuOneTitle {
  font-weight: 600;
  margin: 10px 0 20px;
}
.menuTwo {
  box-sizing: border-box;
  margin: 0 10px 10px;
  color: #f4524e;
}
.menuTwo :hover {
  border-bottom: 1px solid #f4524e;
}
</style>



// WEBPACK FOOTER //
// src/components/SiteMap.vue